import { render } from "./manage-member.vue?vue&type=template&id=1610b096&scoped=true&ts=true"
import script from "./manage-member.vue?vue&type=script&lang=ts"
export * from "./manage-member.vue?vue&type=script&lang=ts"

import "./manage-member.vue?vue&type=style&index=0&id=1610b096&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1610b096"]])

export default __exports__